import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { getLightBorder } from 'Components/utils';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useRightColumnContext } from 'Context/RightColumnContext';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  rootNoPadding: {
    padding: 0,
  },
  rootBottomBorder: {
    ...getLightBorder(theme, { bottom: true }),
  },
  text: {
    flexGrow: 1,
  },
}));

const Header = ({
  padding,
  showBorderBottom,
}) => {
  const { clearRightColumnCollection } = useRightColumnContext();

  const classes = useStyles();
  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootNoPadding]: padding === 'none',
        [classes.rootBottomBorder]: showBorderBottom,
      })}
    >
      <Text
        className={classes.text}
        color={'black'}
        weight={'bold'}
        variant={'h2'}
        align={'left'}
        text={'Details'}
      />
      <IconButton
        onClick={() => {
          return clearRightColumnCollection();
        }}
        color={'primaryGray'}
        title={'Close Details'}
        icon={CloseIcon}
      />
    </Box>
  );
};

Header.defaultProps = {
  padding: 'default',
  showBorderBottom: true,
};

Header.propTypes = {
  padding: PropTypes.oneOf(['none', 'default']),
  showBorderBottom: PropTypes.bool,
};

export default Header;
